(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.v2Initialized === 'true') return;
    root.dataset.v2Initialized = 'true';
        var form = root.querySelector('[data-v2-form]');
        var variantInput = root.querySelector('[data-v2-variant-id]');
        var mainButton = root.querySelector('[data-v2-main-cta]');
        var sticky = root.querySelector('[data-v2-sticky]');
        var stickyButton = root.querySelector('[data-v2-sticky-button]');
        var offers = Array.prototype.slice.call(root.querySelectorAll('[data-v2-offer]'));
        var mainPrice = root.querySelector('[data-v2-cta-price]');
        var mainSavings = root.querySelector('[data-v2-cta-savings]');
        var mainCompare = root.querySelector('[data-v2-cta-compare]');
        var stickyPrice = root.querySelector('[data-v2-sticky-price]');
        var availability = root.querySelector('[data-v2-availability]');
        var availableLabel = root.getAttribute('data-v2-available-label') || 'Disponible';
        var unavailableLabel = root.getAttribute('data-v2-unavailable-label') || 'Indisponible';
        var ctaLabel = root.getAttribute('data-v2-cta-label') || 'Commander';
        var savingsPrefix = root.getAttribute('data-v2-savings-prefix') || 'Économisez';
        var promoCode = root.getAttribute('data-v2-promo-code') || '';
                var promoPercent = Number(root.getAttribute('data-v2-promo-percent') || 0);
                var promoParam = '';
                try {
                  promoParam = new URLSearchParams(window.location.search).get('promo') || '';
                } catch (error) {
                  var queryMatch = window.location.search.match(/[?&]promo=([^&]+)/i);
                  promoParam = queryMatch ? decodeURIComponent(queryMatch[1]) : '';
                }
                var promoActive = !!(
                  (window.location.pathname || '') === '/products/focus-flow' &&
                  promoCode &&
                  promoPercent > 0 &&
                  promoParam.toUpperCase() === promoCode.toUpperCase()
                );
                var promoBanner = root.querySelector('[data-v2-promo-banner]');
            
                        var stickyEnabled = root.getAttribute('data-v2-sticky-enabled') === 'true';
    
        function formatMoney(cents) {
          var amount = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
          return amount + ' €';
        }
    
        function promoPrice(offer) {
          var base = Number(offer.getAttribute('data-price-cents') || 0);
          return promoActive ? Math.round(base * (100 - promoPercent) / 100) : base;
        }
    
        function formatDailyPrice(cents, drinks) {
          return formatMoney(Math.round(Number(cents || 0) / Math.max(1, Number(drinks || 1))));
        }
    
        function applyPromoPresentation() {
          if (!promoActive) return;
          if (promoBanner) promoBanner.hidden = false;
          offers.forEach(function (offer) {
            var base = Number(offer.getAttribute('data-price-cents') || 0);
            var price = promoPrice(offer);
            var priceNode = offer.querySelector('[data-v2-card-price]');
            var nativeCompare = offer.querySelector('[data-v2-card-native-compare]');
            var promoCompare = offer.querySelector('[data-v2-card-promo-compare]');
            var promoComparePrice = offer.querySelector('[data-v2-card-promo-compare-price]');
            var nativeSaving = offer.querySelector('[data-v2-card-native-saving]');
            var promoSaving = offer.querySelector('[data-v2-card-promo-saving]');
            var daily = offer.querySelector('[data-v2-card-daily]');
            if (priceNode) priceNode.textContent = formatMoney(price);
            if (nativeCompare) nativeCompare.hidden = true;
            if (promoCompare) promoCompare.hidden = false;
            if (promoComparePrice) promoComparePrice.textContent = formatMoney(base);
            if (nativeSaving) nativeSaving.hidden = true;
            if (promoSaving) {
              promoSaving.hidden = false;
              promoSaving.textContent = 'Économisez ' + promoPercent + ' %';
            }
            if (daily) daily.textContent = formatDailyPrice(price, offer.getAttribute('data-drinks') || offer.getAttribute('data-boxes')) + (daily.getAttribute('data-v2-unit') || ' / jour');
          });
        }
    
        function selectOffer(offer) {
          offers.forEach(function (item) {
            var selected = item === offer;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
    
          var variantId = offer.getAttribute('data-variant-id');
          var available = offer.getAttribute('data-available') === 'true';
          var price = promoPrice(offer);
          variantInput.value = variantId || '';
          var currentMainPrice = root.querySelector('[data-v2-cta-price]');
          var currentStickyPrice = root.querySelector('[data-v2-sticky-price]');
          if (currentMainPrice) currentMainPrice.textContent = formatMoney(price);
          if (mainSavings) {
            var savingsPct = Number(offer.getAttribute('data-savings-pct') || 0);
            mainSavings.textContent = savingsPct > 0 ? savingsPrefix + ' ' + savingsPct + ' %' : '';
            mainSavings.hidden = savingsPct <= 0;
          }
          if (mainCompare) {
            var compareCents = Number(offer.getAttribute('data-compare-cents') || 0);
            mainCompare.textContent = compareCents > price ? formatMoney(compareCents) : '';
            mainCompare.hidden = compareCents <= price;
          }
          if (currentStickyPrice) currentStickyPrice.textContent = formatMoney(price);
          if (availability) availability.textContent = available ? availableLabel : unavailableLabel;
          if (mainButton) {
            mainButton.disabled = !available;
            mainButton.setAttribute('aria-label', ctaLabel + ' ' + formatMoney(price));
          }
          if (stickyButton) stickyButton.disabled = !available;
        }
    
        offers.forEach(function (offer) {
          offer.addEventListener('click', function () { if (document.documentElement.dataset.baviCartBusy !== 'true') selectOffer(offer); });
          offer.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            if (document.documentElement.dataset.baviCartBusy === 'true') return;
            var index = offers.indexOf(offer);
            var nextIndex = event.key === 'ArrowDown' ? (index + 1) % offers.length : (index - 1 + offers.length) % offers.length;
            offers[nextIndex].focus();
            selectOffer(offers[nextIndex]);
          });
        });
        document.addEventListener('bavi:cart-state', function (event) {
          if (!root.isConnected || event.detail.busy) return;
          var selected = root.querySelector('[data-v2-offer].is-selected');
          if (selected) selectOffer(selected);
        });
        applyPromoPresentation();
        // Acquisition pages do not resolve product.selected_variant in Liquid.
        // Only accept an ID belonging to a rendered offer; preserve the URL.
        var requestedVariantId = '';
        try {
          requestedVariantId = new URLSearchParams(window.location.search).get('variant') || '';
        } catch (error) {
          requestedVariantId = '';
        }
        var requestedOffer = offers.find(function (offer) {
          return requestedVariantId && offer.getAttribute('data-variant-id') === requestedVariantId;
        });
        var initialOffer = requestedOffer || offers.find(function (offer) {
          return variantInput && variantInput.value &&
            offer.getAttribute('data-variant-id') === variantInput.value;
        }) || offers.find(function (offer) {
          return offer.classList.contains('is-selected') && offer.getAttribute('data-available') === 'true';
        }) || offers.find(function (offer) {
          return offer.getAttribute('data-available') === 'true';
        });
        if (initialOffer) {
          selectOffer(initialOffer);
        } else {
          if (variantInput) variantInput.value = '';
          if (mainButton) mainButton.disabled = true;
          if (stickyButton) stickyButton.disabled = true;
          if (mainPrice) mainPrice.textContent = unavailableLabel;
        }
    
        if (stickyButton && form) {
          stickyButton.addEventListener('click', function () {
            if (stickyButton.disabled || !mainButton) return;
            form.requestSubmit(mainButton);
          });
        }
    
        var mainCtaVisible = true;
        var purchaseSectionPassed = false;
        var purchaseEndMarker = root.querySelector('[data-v2-sticky-end]');
        var stickyCheckQueued = false;

        function syncSticky() {
          if (!sticky) return;
          var isMobile = window.matchMedia('(max-width: 767px)').matches;
          var shouldShow = stickyEnabled && isMobile && !mainCtaVisible &&
            purchaseSectionPassed;
          sticky.hidden = !shouldShow;
          sticky.classList.toggle('is-visible', shouldShow);
        }

        function checkStickyBoundaries() {
          if (stickyCheckQueued) return;
          stickyCheckQueued = true;
          window.requestAnimationFrame(function () {
            stickyCheckQueued = false;
            purchaseSectionPassed = !!purchaseEndMarker &&
              purchaseEndMarker.getBoundingClientRect().bottom <= 0;
            syncSticky();
          });
        }

        if ('IntersectionObserver' in window && mainButton && sticky) {
          var ctaObserver = new IntersectionObserver(function (entries) {
            mainCtaVisible = entries[0].isIntersecting;
            syncSticky();
          }, { threshold: 0.1 });
          ctaObserver.observe(mainButton);
        }

        if (sticky) {
          window.addEventListener('scroll', checkStickyBoundaries, { passive: true });
          window.addEventListener('resize', checkStickyBoundaries);
          checkStickyBoundaries();
        }

        var galleryTrack = root.querySelector('[data-v2-gallery-track]');
        var gallerySlides = Array.prototype.slice.call(root.querySelectorAll('[data-v2-slide]'));
        var galleryDots = Array.prototype.slice.call(root.querySelectorAll('[data-v2-gallery-dot]'));
        var galleryCount = root.querySelector('[data-v2-gallery-count]');
    
        function updateGallery(index) {
          var safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));
          galleryDots.forEach(function (dot) {
            var active = Number(dot.getAttribute('data-v2-index') || 0) === safeIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          if (galleryCount) galleryCount.textContent = String(safeIndex + 1).padStart(2, '0') + ' / ' + String(gallerySlides.length).padStart(2, '0');
        }
    
        function goToGallery(index) {
          if (!galleryTrack || !gallerySlides.length) return;
          galleryTrack.scrollTo({ left: gallerySlides[index].offsetLeft, behavior: 'smooth' });
          updateGallery(index);
        }
    
        galleryDots.forEach(function (dot) {
          dot.addEventListener('click', function () { goToGallery(Number(dot.getAttribute('data-v2-index')) || 0); });
        });
        var prevButtons = Array.prototype.slice.call(root.querySelectorAll('[data-v2-gallery-prev]'));
        var nextButtons = Array.prototype.slice.call(root.querySelectorAll('[data-v2-gallery-next]'));
        function currentGalleryIndex() {
          var activeDot = root.querySelector('.bavi-product-achat-v2__dot.is-active');
          return activeDot ? Number(activeDot.getAttribute('data-v2-index') || 0) : 0;
        }
        prevButtons.forEach(function (button) {
          button.addEventListener('click', function () { goToGallery(Math.max(0, currentGalleryIndex() - 1)); });
        });
        nextButtons.forEach(function (button) {
          button.addEventListener('click', function () { goToGallery(Math.min(gallerySlides.length - 1, currentGalleryIndex() + 1)); });
        });
    
        var lightbox = root.querySelector('[data-v2-lightbox]');
        var lightboxImage = root.querySelector('[data-v2-lightbox-image]');
        var lightboxCloseButton = root.querySelector('[data-v2-lightbox-close-button]');
        var previousBodyOverflow = '';
    
        function closeLightbox() {
          if (!lightbox) return;
          lightbox.hidden = true;
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = previousBodyOverflow;
        }
    
        function openLightbox(openButton) {
          if (!lightbox || !lightboxImage) return;
          var image = openButton.querySelector('img');
          if (!image) return;
          lightboxImage.src = image.currentSrc || image.src;
          lightboxImage.alt = image.alt || '';
          previousBodyOverflow = document.body.style.overflow;
          lightbox.hidden = false;
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          if (lightboxCloseButton) lightboxCloseButton.focus();
        }
    
        root.querySelectorAll('[data-v2-gallery-open]').forEach(function (openButton) {
          openButton.addEventListener('click', function () { openLightbox(openButton); });
          openButton.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            openLightbox(openButton);
          });
        });
    
        root.querySelectorAll('[data-v2-lightbox-close]').forEach(function (closeButton) {
          closeButton.addEventListener('click', closeLightbox);
        });
    
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
        });
    
        if (galleryTrack && 'IntersectionObserver' in window) {
          var slideObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) updateGallery(Number(entry.target.getAttribute('data-v2-index')) || 0);
            });
          }, { root: galleryTrack, threshold: 0.65 });
          gallerySlides.forEach(function (slide) { slideObserver.observe(slide); });
        }
  }

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-bavi-achat-v2]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initScope(document); }, { once: true });
  } else {
    initScope(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });
})();
